import { PropsWithChildren } from "react";
import { ReactComponent as RightChevron } from "shared/assets/Icons/right.svg";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export type TitleCardProps = PropsWithChildren & {
  title: string;
  radiusStyle: string;
  onTitleClick?: Function;
};

export const TitleCard = ({ title, radiusStyle, onTitleClick, children }: TitleCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("title-card", radiusStyle, "px-2 py-3")}>
      {onTitleClick && (
        <button className="w-full text-left" aria-label={t("titleCard.titleAriaButton", { title })} onClick={() => onTitleClick()}>
          <h2 className="flex flex-row px-3 items-center">
            <span className="flex-grow text-white">{title}</span>
            <span>
              <RightChevron className="text-white" />
            </span>
          </h2>
        </button>
      )}

      {!onTitleClick && (
        <h2 className="flex flex-row px-3">
          <span className="flex-grow text-white">{title}</span>
        </h2>
      )}

      {children}
    </div>
  );
};

TitleCard.defaultProps = { radiusStyle: "rounded-card" };
